<template>
  <div :class="{
        'part': !isRecExpenseDetails,
        'attachments-part': !isRecExpenseDetails,
        'data-area-rows': isRecExpenseDetails,
        'attachments-row': isRecExpenseDetails
      }"
  >
    <div :class="{'recurring-details-att': isRecExpenseDetails}">
      <!-- Headline -->
      <slot />
  
      <div
        v-for="(attachment, i) in attachmentResponse"
        :key="i"
        :class="{'attachment': !isRecExpenseDetails, 'attachment-area': isRecExpenseDetails}"
      >
        
        <span class="document">
          <f-p-documents :type="attachment.extension.toLowerCase()"></f-p-documents>
          <p :title="attachment.fileName + '.' + attachment.extension">{{ attachment.fileName }}.{{ attachment.extension }}</p>
        </span>
        
        <span class="download details">
          <img src="@/assets/images/payments/download_ico.png" />
          <a :href="attachment.fileUrl" download>
            <span>{{ inputDownloadText }} </span>
            <span>
              <img src="@/assets/images/payments/download_ico.png" alt="download" />
            </span>
          </a>
        </span>
        
      </div>
    </div>
    
  </div>
</template>

<script>
  import FPDocuments from '../FPDocuments';
  
  export default {
    components: {
      'f-p-documents': FPDocuments
    },
    props: {
      isRecExpenseDetails: {
        type: Boolean,
        required: true
      },
      attachmentResponse: {
        type: [Array, Object],
        required: true
      },
      inputDownloadText: {
        type: String,
        required: true
      }
    }
  }
</script>
